import { render, staticRenderFns } from "./macro-form-section.vue?vue&type=template&id=446686e7&scoped=true&"
import script from "./macro-form-section.vue?vue&type=script&lang=js&"
export * from "./macro-form-section.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=446686e7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446686e7",
  null
  
)

export default component.exports